// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__BKhgK","bottom_container":"Footer_bottom_container__2ubMV","top_container":"Footer_top_container__3M9Dz"};